import React, { useRef } from 'react'
import { Divider } from 'antd'
import { ChartContainer, ChartWrapper, ChartWrapperInner, DividerDownloadWrapper, Title } from '../invoice.styled'
import { Bar, Doughnut, HorizontalBar, Line } from 'react-chartjs-2'
import Taiwan from '../../DashboardSetting/charts/map/Taiwan'
import { DownloadOutlined, InboxOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { formatChart, formatSvg, onDownload } from './donwload'

function ChartComponent (props) {
  const { title, data, type, propsFunc, wrapperProps = {}, innerProps = {}, useDivider, customLabel, chartState } = props || {}
  const { t: ln_t } = useTranslation()
  const chartRef = useRef()

  const handleDownload = async () => {
    const formatFunc = type === 'map' ? formatSvg : formatChart
    const url = await formatFunc(chartRef)
    if (!url) return
    onDownload(url, title)
  }

  const chartTypes = {
    bar: props => <Bar {...props} />,
    horizontalBar: props => <HorizontalBar {...props} />,
    map: ({ ref, ...props }) => <Taiwan {...props} reference={ref} />,
    line: props => <Line {...props} />,
    doughnut: props => <Doughnut {...props} />
  }

  return <ChartWrapper {...wrapperProps}>
    {useDivider
      ? <DividerDownloadWrapper>
          <Divider plain>{title}</Divider>
          <DownloadOutlined className='downloadHide' onClick={handleDownload} />
        </DividerDownloadWrapper>
      : <Title>{title}</Title>}
    <ChartWrapperInner {...innerProps} flexColumn={customLabel?.position === 'down' ? 1 : 0}>
      {data
        ? <>
          <ChartContainer>{chartTypes[type]?.({ ...propsFunc({ data, ln_t, chartState }) || {}, ref: chartRef })}</ChartContainer>
          {Boolean(customLabel) && Boolean(data) && customLabel?.component}
        </>
        : <div style={{ padding: '60px 0' }}>
          <InboxOutlined style={{ color: 'rgba(0,0,0,.3)' }} /> {ln_t('dashboard.noData')}
        </div>}
    </ChartWrapperInner>
  </ChartWrapper>
}

export default ChartComponent
